<template>
  <div class="h-topbar">
    <div v-show="userType==1">
        <div class="h-topbar-expandIcon">
        <!-- 展开 -->
        <!-- <h-icon name="navicon"></h-icon> -->
        <!-- <span>LOGO</span> -->
        <!-- <span> -->
          <a href="javascript:void(0);" @click="clickLogo" style="display: flex;font-size: 26px;">
             <img src="../../assets/gtn-logo-yun.png" height="40px" style="margin:10px 10px 10px 0;">
            <!-- <img src="../../assets/logo.png" height="40px" style="margin:10px 10px 10px 0;"> -->
            <span v-if="roles!='coper'">小营加营销开发平台</span>
          </a>
        <!-- </span> -->
      </div>

      <div class="h-topbar-tool" ref="topbarTool">
        <h-menu theme="dark" mode="horizontal">
          <span class="pT" @click="packHandler()"  v-if="roles!='coper'">我要接包</span>
          <span class="pT" @click="shakyHandler()">我的活动</span>
          <span class="pT" v-if="roles=='admin'||roles=='ooper'" @click="baseHandler()">系统管理</span>
         <!--  <div  class="pT ">
            <span class="icon-interactive" style="width: 20px;height: 20"></span>
            <span style="display: inline-block;width: 10px;height: 10px;background: red;border-radius: 100%;"></span>
          </div> -->
          <!-- <span  class="pT" @click="helpHandler"  v-if="roles!='coper'">帮助与支持</span> -->
          <h-submenu name='1' class="toolLast" style="margin-right: 15px;">
            <template slot='title'>
              <!-- <h-icon name="mine"></h-icon> -->
              <span>{{userName}}</span>
            </template>
            <!-- <h-menu-item name='5-1' disabled>
              <h-icon name="mine"></h-icon>
              <span>个人中心</span>
            </h-menu-item> -->
            <h-menu-item name='5-2' @click.native="handleResetPass">
              <h-icon name="editor"></h-icon>
              <span>修改密码</span>
            </h-menu-item>
            <h-menu-item name='5-3' @click.native="logout">
              <h-icon name="delete"></h-icon>
              <span>退出登录</span>
            </h-menu-item>
          </h-submenu>
        </h-menu>
      </div>
    </div>

    <div v-show="userType==0">
        <div class="h-topbar-expandIcon">
        <!-- 展开 -->
        <!-- <h-icon name="navicon"></h-icon> -->
        <!-- <span>LOGO</span> -->
        <span>
            <a href="javascript:void(0);" @click="clickLogo" style="display: flex;font-size: 26px;">
              <img src="../../assets/gtn-logo-yun.png" height="40px" style="margin:10px 10px 10px 0;">
            <!-- <img src="../../assets/logo.png" height="40px" style="margin:10px 10px 10px 0;"> -->
            <span>小营加营销开发平台</span>
            <!-- <img src="../../assets/logo-title.png" height="40px" style="margin:10px 0"> -->
          </a>
        </span>
      </div>

      <div class="h-topbar-tool" ref="topbarTool">
        <h-menu theme="dark" mode="horizontal">
           <span class="pT" @click="packHandler()">我要接包</span>
          <span class="pT" @click="shakyHandler2()">我的活动</span>
          <span class="pT" v-if="roles=='admin'||roles=='ooper'" @click="baseHandler()">系统管理</span>
         <!--  <div  class="pT ">
            <span class="icon-interactive" style="width: 20px;height: 20"></span>
            <span style="display: inline-block;width: 10px;height: 10px;background: red;border-radius: 100%;"></span>
          </div> -->
          <span  class="pT" @click="helpHandler">帮助与支持</span>
          <h-submenu name='1' class="toolLast" style="margin-right: 15px;">
            <template slot='title'>
              <!-- <h-icon name="mine"></h-icon> -->
              <span>{{userName}}</span>
            </template>
            <!-- <h-menu-item name='5-1' disabled>
              <h-icon name="mine"></h-icon>
              <span>个人中心</span>
            </h-menu-item> -->
          <!--   <h-menu-item name='5-2' @click.native="handleResetPass2">
              <h-icon name="editor"></h-icon>
              <span>修改密码</span>
            </h-menu-item> -->
            <h-menu-item name='5-3' @click.native="userlogout">
              <h-icon name="delete"></h-icon>
              <span>退出登录</span>
            </h-menu-item>
          </h-submenu>
        </h-menu>
      </div>
    </div>

    <h-msg-box v-model="setPassword" title="重置密码" :mask-closable="false" style="text-align:left">
      <h-form ref="setPassForm" :model="setPassForm" :label-width="80">
        <h-form-item prop="oldPassword" label="当前密码" required>
          <h-input type="password" v-model="setPassForm.oldPassword" placeholder="请输入当前密码"></h-input>
        </h-form-item>
        <h-form-item prop="newPassword" label="新密码" required>
          <h-input type="password" v-model="setPassForm.newPassword" placeholder="请输入新密码"></h-input>
        </h-form-item>
        <h-form-item prop="newPasswordCheck" label="新密码确认" required :rules="validNewPassCheck">
          <h-input type="password" v-model="setPassForm.newPasswordCheck" placeholder="请再次输入新密码"></h-input>
        </h-form-item>
      </h-form>
      <div slot="footer">
        <h-button @click="setPassword = false">取消</h-button>
        <h-button type="primary" @click="handleSetPassword">确认</h-button>
      </div>
    </h-msg-box>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
import { changePwd, initMsg } from '@/api/login'
import { allToggleClass } from '@/utils'
import {getUserCenterLogout } from "@/api/bizApi/commonUtil";
// import secret from '../../../secret/secret.js'
import secret from '../../secret/secret.js'
export default {
  data() {
    // 新密码框校验

    // 确认密码框校验
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入您的新密码'));
      } else if (value !== this.setPassForm.newPassword) {
        callback(new Error('两次密码输入不一致'));
      } else {
        callback();
      }
    }
    return {
      showInput: false,
      locationHost:'',
      locationProtocol:'',
      userType:'',//用户类型1是本地0是用户中心
      roles:'',//用户角色
      setPassForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordCheck: ''
      },
      validNewPassCheck: {
        validator: validatePassCheck,
        trigger: 'blur'
      },
      setPassword: false,
      submitLoading: true,
      locktime: this.LOCAL_CONFIG.LOCK_TIME,
      theme: this.LOCAL_CONFIG.THEME,
      sysName: this.LOCAL_CONFIG.SYS_NAME,
      appname: '',
      canPage: true,
      isComputed: false,
      appList: [{
          value: 'tip1',
          label: '搜索提示1'
        },
        {
          value: 'tip2',
          label: '搜索提示2'
        },
        {
          value: 'tip3',
          label: '搜索提示3'
        }
      ],
      allAppList: [],
      navWidth: 0,
      showMore: false,
      hideNavList: [],
      userName: ''
    }
  },
  components: {
    LockScreen
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'menusRoot',
      'activeIndex'
    ]),
    hideNavListLength() {
      return this.hideNavList.length
    }
  },
  watch: {
    theme() {
      allToggleClass(document.getElementsByTagName('html')[0], this.theme)
    },
    setPassword(val) {
      if (!val) {
        this.$refs.setPassForm.resetFields()
      }
    },
    hideNavListLength(val) {
      if (val > 0) {
        this.showMore = true
      } else {
        this.showMore = false
      }
    }
  },
  methods: {
    handleShowInput() {
      this.showInput = !this.showInput
    },
    stopEvent($event) {
      $event.stopEvent()
      $event.preventDefault();
    },
    //我要接包按钮函数
    packHandler(){

      window.open(window.LOCAL_CONFIG.PACKINGURL);
    },

      //帮助与支持按钮函数
    helpHandler(){
       this.$router.push({path:'/help'});
    },
    //我的活动点击函数
    shakyHandler(){
      window.sessionStorage.removeItem('sys')
      this.$router.push({path:'/mainIndex'})

    },
     //用户中心点击我的活动函数
    shakyHandler2(){
     window.sessionStorage.removeItem('sys')
      // this.$router.push({path:'/mainIndex'})
       window.location.href=window.location.href.split("#")[0]+'#/mainIndex'

    },
    //系统管理按钮
    baseHandler(){
      sessionStorage['sys']=1
      this.$router.push({path:'/system/operator'})
     // window.location.href=this.locationProtocol+'//'+this.locationHost+'/#/system/operator'
    },

    //帮助点击函数
    helpHandler(){
      window.open(window.location.href.split("#")[0]+'#/help',"_blank");
       //window.location.href=this.locationProtocol+'//'+this.locationHost+'/#/help/list'
    },




    // 换肤
    handleChangeTheme(color) {
      this.theme = color
    },
    handleResetPass() {
      this.handleResetForm('setPassForm')
      this.setPassword = true
    },
    //用户中心密码修改
    handleResetPass2() {
      window.location.href=window.LOCAL_CONFIG.LOGONURL+'/site/resetPasswd.htm'
    },
    handleResetForm(name) {
      this.$refs[name].resetFields();
    },
    handleSetPassword() {
      this.$refs['setPassForm'].validate((valid) => {
        if (valid) {
          changePwd(this.setPassForm.oldPassword, this.setPassForm.newPassword).then(res => {
              if (res.data.errcode == '0') {
                 this.setPassword = false
                 this.$hMsgBox.success({
                    content: '密码修改成功! 请使用新密码重新登录。',
                    onOk: ()=>{
                      this.logout()
                    }
                });
              }

          }).catch(error => {
            if(error.response.data){
                this.$hMessage.info(error.response.data.error_msg)
            } else {
              this.$hMessage.info("网络异常")
            }
          })
        } else {
          this.$hMessage.error('请正确填写密码!')
        }
      })
    },
    logout() {
      this.$store.dispatch('Logout').then(() => {
        sessionStorage['local'] = 'local';
				if(this.roles=='coper'){
					sessionStorage['xyj'] = 'xyj';
				}
        location.reload()
      })
    },

    //用户中心的退出函数
    userlogout(){
      //window.location.href=window.LOCAL_CONFIG.LOGINURL+'/iuccasserver/logout?service='+this.locationProtocol+'//'+this.locationHost+'/'
      //window.location.href=this.locationProtocol+'//'+this.locationHost+'/mainIndex'
        getUserCenterLogout().then((res) => {
          if (res.data.errcode == '0') {
            this.$message({
              type: 'success',
              message: '退出成功'
            });
            // debugger
             this.$store.dispatch('Logout').then(() => {
              sessionStorage['local'] = 'local';
              location.reload()
            })
             window.location.href=window.LOCAL_CONFIG.LOGINURL+'/iuccasserver/logout?service='+window.location.href.split("#")[0]+''
          } else {
            this.$message({
              type: 'fail',
              message: res.data.errmsg
            })

          }

        });


    },


    activeSidebar(index) {
      if (index >= 0) {
        this.$store.dispatch('ActiveRootIndex', index)
      }
      // let item = this.menusRoot[this.activeIndex]
      // 防止页面刷新时会跳转根页面
      // if(this.$route.matched[0].path !== item.url) {
      //   this.$router.push({path: item.url})
      // }
    },

    computedNavWidth() {
      this.hideNavList = []
      if (this.$refs.topbarNav) {
        let logoWidth = this.$refs.topbarLogo ? this.$refs.topbarLogo.clientWidth : 0
        let toolWidth = this.$refs.topbarTool ? this.$refs.topbarTool.clientWidth : 0
        let searchWidth = this.$refs.topbarSearch ? this.$refs.topbarSearch.clientWidth : 0
        this.navWidth = document.getElementsByClassName('h-topbar')[0].clientWidth - logoWidth - toolWidth - searchWidth - 20
        let that = this
        this.$nextTick(function() {
          // 对nav menu子元素从后往前遍历，将超出部分保存至hideNavList
          // menu总长度 that.$refs.topbarNav.children[0].children.length === that.menusRoot.length
          let menuRootWidth = document.getElementsByClassName('h-topbar-navMenu')[0].clientWidth
          // menu子元素
          let menuChildren = document.getElementsByClassName('h-topbar-navMenu')[0].children
          if (menuChildren && menuChildren.length > 0 && that.navWidth < menuRootWidth) {
            for (let i = menuChildren.length - 1; i >= 0; i--) {
              if (that.navWidth < menuRootWidth) {
                that.hideNavList.splice(0, 0, that.menusRoot[i])
              } else {
                break
              }
              menuRootWidth = menuRootWidth - menuChildren[i].clientWidth
            }
          }
        })
      }
    },
    clickLogo(){
      this.$router.push("/mainIndex")
    }
  },
  created() {
    this.locationHost=window.location.host
    this.locationProtocol=window.location.protocol;
    this.userName = sessionStorage['username'];
    this.userType = sessionStorage['userType'];
    this.roles = JSON.parse(sessionStorage['roles']);
    // 输入其他根目录下的路径时，切换sidebar
    if (this.menusRoot && this.menusRoot.length > 0) {
      if (this.$route.path.indexOf(this.menusRoot[this.activeIndex].url) < 0) {
        let urlArr = this.$route.path.split('/')
        let curUrl = '/' + urlArr[1]
        for (let [key, value] of this.menusRoot.entries()) {
          if (curUrl === value.url) {
            this.activeSidebar(key)
            return
          }
        }
      } else {
        // 更新对应的sidebar
        this.activeSidebar(this.activeIndex)
      }
    }

  },
  mounted() {
    document.getElementsByTagName('html')[0].className = this.theme;
    this.computedNavWidth()
    document.addEventListener('resize', this.computedNavWidth())
  }
}

</script>
<style scoped lang="scss">
.pT{
  float: left;
  margin-right:20px;
}
.pT:hover{
  cursor:pointer
}
</style>



// WEBPACK FOOTER //
// src/views/frame/Topbar.vue